export default "__VITE_ASSET__DxNccAnf__"